export default __webpack_public_path__ + "static/media/MaskGroup304.bf7aa569.png";